/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { LeadCalendarEventType } from './LeadCalendarEventType';
import {
    LeadCalendarEventTypeFromJSON,
    LeadCalendarEventTypeFromJSONTyped,
    LeadCalendarEventTypeToJSON,
    LeadCalendarEventTypeToJSONTyped,
} from './LeadCalendarEventType';

/**
 * 
 * @export
 * @interface LeadCalendarEvent
 */
export interface LeadCalendarEvent {
    /**
     * 
     */
    lead_id: string;
    /**
     * The lead's duplicate_group_id, or its own lead_id when it has no duplicates.
     */
    duplicate_group_id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    event_type: LeadCalendarEventType;
    /**
     * 
     */
    event_date: Date;
    /**
     * Actual start of the lead's current care segment, including historical admission when the current status is discharged. Null when no valid start exists before this event.
     */
    care_start_date?: Date;
    /**
     * expected_end_of_care only. True when the scheduled discharge date is confirmed; false means projected.
     */
    is_date_confirmed?: boolean;
    /**
     * 
     */
    payer_type: string;
    /**
     * 
     */
    payer_name: string;
    /**
     * Bed Board room name of the lead's current bed occupancy, or of their most recent one if they have moved out. Null when the lead has no Bed Board occupancy.
     */
    room_name: string;
}



/**
 * Check if a given object implements the LeadCalendarEvent interface.
 */
export function instanceOfLeadCalendarEvent(value: object): value is LeadCalendarEvent {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('duplicate_group_id' in value) || value['duplicate_group_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('event_type' in value) || value['event_type'] === undefined) return false;
    if (!('event_date' in value) || value['event_date'] === undefined) return false;
    if (!('payer_type' in value) || value['payer_type'] === undefined) return false;
    if (!('payer_name' in value) || value['payer_name'] === undefined) return false;
    if (!('room_name' in value) || value['room_name'] === undefined) return false;
    return true;
}

export function LeadCalendarEventFromJSON(json: any): LeadCalendarEvent {
    return LeadCalendarEventFromJSONTyped(json, false);
}

export function LeadCalendarEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCalendarEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'duplicate_group_id': json['duplicate_group_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'facility_id': json['facility_id'],
        'event_type': LeadCalendarEventTypeFromJSON(json['event_type']),
        'event_date': (json['event_date'] == null ? json['event_date'] : parseDate(json['event_date'])),
        'care_start_date': json['care_start_date'] == null ? undefined : (parseDate(json['care_start_date'])),
        'is_date_confirmed': json['is_date_confirmed'] == null ? undefined : json['is_date_confirmed'],
        'payer_type': json['payer_type'],
        'payer_name': json['payer_name'],
        'room_name': json['room_name'],
    };
}

export function LeadCalendarEventToJSON(json: any): LeadCalendarEvent {
    return LeadCalendarEventToJSONTyped(json, false);
}

export function LeadCalendarEventToJSONTyped(value?: LeadCalendarEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'duplicate_group_id': value['duplicate_group_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'facility_id': value['facility_id'],
        'event_type': LeadCalendarEventTypeToJSON(value['event_type']),
        'event_date': value['event_date'] == null ? value['event_date'] : serializeDate(value['event_date']),
        'care_start_date': value['care_start_date'] == null ? value['care_start_date'] : serializeDate(value['care_start_date']),
        'is_date_confirmed': value['is_date_confirmed'],
        'payer_type': value['payer_type'],
        'payer_name': value['payer_name'],
        'room_name': value['room_name'],
    };
}

